document.addEventListener('DOMContentLoaded', function() {
  // Select all video elements using their class
  var videos = document.querySelectorAll('.instant-video__player');

  if (videos.length > 0) {
    // Iterate over each video element
    videos.forEach(function(video) {
      // Skip the specific video by checking its parent container's class
      if (video.closest('.instant-video__container.i0mjXzCPoGIxm4pCW')) {
        return; // Skip this video
      }

      // Remove the default video controls
      video.removeAttribute('controls');
      video.controls = false;

      // Enable looping of the video
      video.setAttribute('loop', '');
      video.loop = true;

      // Ensure the video plays inline on mobile devices
      video.setAttribute('playsinline', '');
      video.playsInline = true;

      // Mute the video to allow autoplay without user interaction
      video.setAttribute('muted', '');
      video.muted = true;

      // Enable autoplay
      video.setAttribute('autoplay', '');
      video.autoplay = true;

      // Disable picture-in-picture (PiP) functionality
      video.setAttribute('disablepictureinpicture', '');
      video.disablePictureInPicture = true;

      // Disable remote playback (e.g., casting to other devices)
      video.setAttribute('disableremoteplayback', '');
      video.disableRemotePlayback = true;

      // Optionally, reload the video to apply changes immediately
      video.load();
    });
  } else {
    console.error('Video elements not found');
  }
});
